import { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Share2, Lock } from "lucide-react";
import { API } from "../App";

const ShareExerciseDialog = ({ open, entryId, exerciseType, onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleShare = async () => {
    setLoading(true);
    try {
      await axios.put(`${API}/patient/toggle-share`, {
        entry_id: entryId,
        exercise_type: exerciseType,
        shared: true,
      }, { withCredentials: true });
      onClose(true);
    } catch (e) {
      console.error("Share error:", e);
      onClose(false);
    } finally {
      setLoading(false);
    }
  };

  if (!open || !entryId) return null;

  return (
    <Dialog open={open} onOpenChange={() => onClose(false)}>
      <DialogContent className="max-w-sm" data-testid="share-exercise-dialog">
        <DialogTitle className="sr-only">Partager avec votre therapeute</DialogTitle>
        <DialogDescription className="sr-only">
          Confirmer le partage de cet exercice avec votre therapeute
        </DialogDescription>
        <div className="flex flex-col items-center gap-4 py-4 text-center">
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
            <Share2 className="w-7 h-7 text-primary" />
          </div>
          <div>
            <h3 className="font-heading text-lg font-semibold mb-1">
              Partager avec votre therapeute ?
            </h3>
            <p className="text-sm text-muted-foreground">
              Souhaitez-vous que votre therapeute puisse consulter le contenu de cet exercice ?
            </p>
          </div>
          <div className="flex gap-3 w-full">
            <Button
              variant="outline"
              className="flex-1 gap-2"
              onClick={() => onClose(false)}
              data-testid="share-dialog-decline"
            >
              <Lock className="w-4 h-4" />
              Non
            </Button>
            <Button
              className="flex-1 gap-2 bg-primary hover:bg-primary/90"
              onClick={handleShare}
              disabled={loading}
              data-testid="share-dialog-accept"
            >
              <Share2 className="w-4 h-4" />
              {loading ? "..." : "Partager"}
            </Button>
          </div>
          <p className="text-xs text-muted-foreground">
            Vous pourrez modifier ce choix depuis vos exercices
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareExerciseDialog;
